import { useNavigation } from '@react-navigation/native';
import TENANT_ID from '../config/TenantId';
import { Metric } from '../metrics';
import { toErrorMessage } from '../util';
import Debug from '../util/Debug';
function useSetTitle() {
    let setTitle = (_title) => {
        Debug.warn(`Unable set title ${_title} due to useSetTitle error`, 'useSetTitle can only be used in functional components inside of a screen placement');
    };
    try {
        const navigation = useNavigation();
        setTitle = (title) => {
            const { setOptions } = navigation;
            setOptions({ title });
            Metric('SetTitle', TENANT_ID, {
                attributes: {
                    title,
                },
            }).put();
        };
    }
    catch (error) {
        Metric('UseSetTitleError', TENANT_ID, {
            attributes: {
                error: toErrorMessage(error),
            },
        }).put();
    }
    return setTitle;
}
export default useSetTitle;
//# sourceMappingURL=useSetTitle.js.map